<template>
  <div>
    <v-row no-gutters>
      <v-col lg="12" md="12" cols="12">
        <p>{{ $t("membershipRegistration.text_step_1") }}</p>
      </v-col>
      <v-col lg="4" md="4" sm="8" cols="12" class="text-left">
        <v-text-field
          :label="$t('membershipRegistration.label_search')"
          :hint="$t('membershipRegistration.hint_search')"
          persistent-hint
          outlined
          dense
          v-model="searchOrganizationLocal"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col
        v-for="(item, i) in orgItemsFiltered"
        :key="i"
        cols="12"
        class="mb-4"
      >
        <v-card :style="`background: ${colorCard}`">
          <div
            class="d-flex flex-no-wrap justify-space-between"
            :style="{ minHeight: windowWidth >= 600 ? '100px' : '80px' }"
          >
            <v-avatar
              class="ma-3"
              :size="windowWidth < 600 ? 60 : 80"
              tile
              style="margin-top: auto !important; margin-bottom: auto !important;"
            >
              <ImageCard
                :src="item.photo"
                :urlImage="item.photo"
                class="img-resp"
              />
            </v-avatar>
            <div style="width: 100%" v-if="windowWidth >= 600">
              <v-card-title
                v-text="item.orgName"
                style="padding: 6px 16px 0;"
              ></v-card-title>

              <v-card-actions>
                <v-btn
                  :color="`${buttonColor}`"
                  class="btn_next"
                  @click="nextStepOrg(item)"
                  >{{
                    $t("membershipRegistration.select_organization")
                  }}</v-btn
                >
              </v-card-actions>
            </div>
          </div>

          <div
            class="d-flex flex-no-wrap justify-space-between"
            v-if="windowWidth < 600"
          >
            <div style="width: 100%">
              <v-card-title
                v-text="item.orgName"
                style="padding: 6px 16px 0;"
              ></v-card-title>

              <v-card-actions>
                <v-btn
                  :color="`${buttonColor}`"
                  class="btn_next next_rsp"
                  @click="nextStepOrg(item)"
                  >{{
                    $t("membershipRegistration.select_organization")
                  }}</v-btn
                >
              </v-card-actions>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  VRow,
  VCol,
  VTextField,
  VCard,
  VAvatar,
  VCardTitle,
  VCardActions,
  VBtn,
} from "vuetify/lib";

import ImageCard from "@/components/ImageCard";

export default {
  props: [
    "searchOrganization",
    "orgItemsFiltered",
    "windowWidth",
    "buttonColor",
    "colorCard",
  ],
  components: {
    VRow,
    VCol,
    VTextField,
    VCard,
    VAvatar,
    VCardTitle,
    VCardActions,
    VBtn,
    ImageCard,
  },
  data() {
    return {
      searchOrganizationLocal: ''
    }
  },
  watch:
  {
    searchOrganizationLocal(search){
      this.$emit('updateSearchOrganization', search);
    }
  },
  methods: {
    nextStepOrg(item) {
      this.$emit("next-step-org", item);
    },
  },
};
</script>

<style></style>
